export default __webpack_public_path__ + "static/media/office1small.06c41946.jpg";